import { scaleValue } from '../components/scaleValue/ScaleValue';
import { USER_INFO } from '../redux/constant';

export const mobileRegex =
  /(0|\+98)?([ ]|-|[()]){0,2}9[0|1|2|3|4|5|6|7|8|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/gi;

export const incomeSource = [
  {
    Key: 'Capatian gains (kWh)',
    Value: '6.899',
  },
  {
    Key: 'Currencies',
    Value: 'Cent (¢)',
  },
  {
    Key: 'CO Reduced (kg)',
    Value: '0.22',
  },
  {
    Key: 'SO Reduced (kg)',
    Value: '0.645',
  },
];

export const columns = [
  {
    // title: 'Capatian gains (kWh)',
    dataIndex: 'Key',
    align: 'left',
    width: 250,
  },
  {
    // title: '6.899',
    dataIndex: 'Value',
    align: 'left',
  },
];
export const informationSource = [
  {
    Key: 'Plant Name',
    Value: 'Atrabad 2 & 3',
  },
  {
    Key: 'Power Station ID',
    Value: '10048707',
  },
  {
    Key: 'Plant Installation Date',
    Value: '2023-11-05',
  },
  {
    Key: 'Design Power',
    Value: '4500kW',
  },
  {
    Key: 'Planned Generation',
    Value: '165.0TL01680578',
  },
  {
    Key: 'Design Companies',
    Value: 'Mana Mehr Energy Nasim.co',
  },
];

export const locationSource = [
  {
    Key: 'Region',
    Value: '33',
  },
  {
    Key: 'Address',
    Value: '---',
  },
  {
    Key: 'calendar',
    Value: '(GMT +03:00)',
  },
  {
    Key: 'Latitude',
    Value: '32.38420',
  },
  {
    Key: 'Longitude',
    Value: '53.81898',
  },
];

export const CategoryOptions = [
  {
    title: 'ALL',
    value: 'ALL',
  },
  {
    title: 'INVERTER',
    value: 'INVERTER',
  },
  {
    title: 'SENSOR',
    value: 'SENSOR',
  },
  {
    title: 'METER',
    value: 'METER',
  },
  {
    title: 'RELAY',
    value: 'RELAY',
  },
  {
    title: 'RTU',
    value: 'RTU',
  },
  {
    title: 'STRING MONITORING',
    value: 'STRING MONITORING',
  },
];
export const EventOptions = [
  {
    title: 'INVERTER',
    value: 'INVERTER',
  },
  {
    title: 'METER',
    value: 'METER',
  },
  {
    title: 'SENSOR',
    value: 'SENSOR',
  },
  {
    title: 'RELAY',
    value: 'RELAY',
  },
  {
    title: 'RTU',
    value: 'RTU',
  },
  {
    title: 'STRING MONITORING',
    value: 'STRING MONITORING',
  },
];

export const equipmentOptions = [
  {
    title: 'INVERTER',
    value: 'INVERTER',
  },
  {
    title: 'SENSOR',
    value: 'SENSOR',
  },
  {
    title: 'METER',
    value: 'METER',
  },
  {
    title: 'RELAY',
    value: 'RELAY',
  },
  {
    title: 'RTU',
    value: 'RTU',
  },
  {
    title: 'STRING MONITORING',
    value: 'STRING MONITORING',
  },
];

export function getLoggedInUser() {
  const user = localStorage.getItem(USER_INFO);
  return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
}

export const toastMessage = (txt, color, deviceInfoToast) => {
  return {
    content: txt,
    style: {
      marginTop: '5vh',
      color: color,
      // marginLeft: "75vw",
    },
    duration: 3,
  };
};

export const SORT_REALTIME = 'realtime';
export const SORT_DAILY = 'daily';
export const SORT_MONTHLY = 'monthly';
export const SORT_YEARLY = 'yearly';
export const SORT_ALL = 'all';

export const chartRangeOptions = [
  { title: 'Daily', value: SORT_REALTIME },
  // { title: 'Weekly', value: SORT_DAILY },
  { title: 'Monthly', value: SORT_MONTHLY },
  { title: 'Yearly', value: SORT_YEARLY },
  { title: 'All', value: SORT_ALL },
];

export const METRICS_MAX = 'MAX';
export const METRICS_MIN = 'MIN';
export const METRICS_SUM = 'SUM';
export const METRICS_AVG = 'AVG';

export const chartMetricsOptions = [
  { title: METRICS_MAX, value: METRICS_MAX },
  { title: METRICS_MIN, value: METRICS_MIN },
  { title: METRICS_AVG, value: METRICS_AVG },
  { title: METRICS_SUM, value: METRICS_SUM },
];
export const INTERVAL_1 = 1;
export const INTERVAL_15 = 15;
export const INTERVAL_30 = 30;
export const INTERVAL_60 = 60;

export const chartIntervalOptions = [
  { title: "1'", value: INTERVAL_1 },
  { title: "15'", value: INTERVAL_15 },
  { title: "30'", value: INTERVAL_30 },
  { title: "60'", value: INTERVAL_60 },
];

export const getStatusButtonClass = (status) => {
  switch (status) {
    case 'red':
      return 'bg-[#f00707]';
    case 'gray':
      return 'bg-[#A0A09F]';
    case 'grey':
      return 'bg-[#A0A09F]';
    case 'green':
      return 'bg-[#00C073]';
    case 'yellow':
      return 'bg-[#FFCD2F]';
    default:
      return 'bg-[#A0A09F]';
  }
};

export const deviceStatusText = (status) => {
  return `Status : ${status}`;
};

export const wait = (delayMs) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });
};
export function formattedNumber(value, unit, weekChart = false) {
  const { scaledValue, scale } = scaleValue(value, unit);
  return `${scaledValue} ${scale}`;
  // return `${scaledValue || '0'} ${scale}`;
}
export const PHASE1 = 'AtrAbad_2';
export const PHASE2 = 'AtrAbad_3';
